import React from "react";
import "./Navbar.scss";
import backimg from "../assets/Home-assets/back2.png";

const ESC_KEY_CODE = "Escape";

const NavigationMenu = (props) => {
  const { navOpen, navIsAnimating, closeNav } = props;
  const keyPressHandler = ({ key }) => {
    if (key === ESC_KEY_CODE && navOpen) {
      closeNav();
    }
  };
  React.useEffect(() => {
    window.addEventListener("keydown", keyPressHandler);
    return () => {
      window.removeEventListener("keydown", keyPressHandler);
    };
  }, [navOpen]);
  const classes = `${navOpen ? " active" : ""}${
    navIsAnimating ? " is-animating" : ""
  }`;
  return (
    <div className={`navigation-menu${classes}`}>
      <div className="wrap">
        <div className="cols">
          <div className="col col-left col-links">
            <ul className="links">
              <li className="link">
                <a href="/" rel="noopener noreferrer" aria-label="Navigates to">
                  HOME
                </a>
              </li>
              <li className="link">
                <a
                  href="/Dashboard"
                  rel="noopener noreferrer"
                  aria-label="Navigates to"
                >
                  DASHBOARD
                </a>
              </li>
              <li className="link">
                <a
                  href="/Collection"
                  rel="noopener noreferrer"
                  aria-label="Navigates to"
                >
                  COLLECTION
                </a>
              </li>
              <li className="link">
                <a
                  href="/About"
                  rel="noopener noreferrer"
                  aria-label="Navigates to"
                >
                  ABOUT US
                </a>
              </li>
              <li className="link">
                <a
                  href="/Contact"
                  rel="noopener noreferrer"
                  aria-label="Navigates to"
                >
                  CONTACT US
                </a>
              </li>
              <li className="link">
                <a
                  href="https://pixalaclikdblogs.wordpress.com/home/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Navigates to"
                >
                  BLOG
                </a>
              </li>
              <li className="link">
                <a
                  href="/Login"
                  rel="noopener noreferrer"
                  aria-label="Navigates to"
                >
                  LOGIN
                </a>
              </li>
            </ul>
          </div>
          <div className="col col-right col-image">
            <img className="astro" src={backimg} alt=".." />
          </div>
        </div>
      </div>
    </div>
  );
};

const Header = (props) => {
  const { navOpen, navIsAnimating, toggleNavHandler } = props;
  return (
    <header className="header">
      <div className="wrap">
        <button
          className={`nav-button${navIsAnimating ? " is-animating" : ""}`}
          type="button"
          aria-label="Toggle Navigation"
          onClick={(event) => toggleNavHandler(event)}
        >
          <span className={`label--nav-closed${!navOpen ? " active" : ""}`}>
            <i class="fas fas fa-home" style={{ fontSize: "30px" }}></i>
          </span>
          <span className={`label--nav-open${navOpen ? " active" : ""}`}>
            <i
              class="fa fa-close"
              style={{ fontSize: "30px", color: "white" }}
            ></i>
          </span>
        </button>
      </div>
    </header>
  );
};

class Navbar extends React.Component {
  state = {
    navOpen: false,
    navIsAnimating: false,
  };

  toggleNav = (event) => {
    event.preventDefault();
    const { navOpen } = this.state;
    if (event) event.preventDefault();
    this.setState({
      navIsAnimating: true,
    });
    if (navOpen) document.body.classList.remove("nav-open");
    if (!navOpen) document.body.classList.add("nav-open");
    setTimeout(() => {
      this.setState({
        navIsAnimating: false,
        navOpen: !navOpen,
      });
    }, 500);
  };

  openNav = (event) => {
    if (event) event.preventDefault();
    document.body.classList.add("nav-open");
    this.setState({
      navOpen: true,
    });
  };

  closeNav = () => {
    document.body.classList.remove("nav-open");
    this.setState({
      navOpen: false,
    });
  };

  render() {
    const { navOpen, navIsAnimating } = this.state;
    return (
      <div className="layout">
        <Header
          navOpen={navOpen}
          toggleNavHandler={(event) => this.toggleNav(event)}
          navIsAnimating={navIsAnimating}
        />
        <NavigationMenu
          navOpen={navOpen}
          navIsAnimating={navIsAnimating}
          closeNav={(event) => this.closeNav(event)}
          toggleNavHandler={(event) => this.toggleNav(event)}
        />
      </div>
    );
  }
}
export default Navbar;
